import classNames from 'classnames';
import React, { useRef, useState } from 'react';

export interface AccordionProps {
    title: string;
    content: string;
}

function Accordion(props: AccordionProps) {
    const [setActive, setActiveState] = useState(false);
    const [setHeight, setHeightState] = useState('0px');

    const content = useRef<any>();

    function toggleAccordion(e: any) {
        e.preventDefault();
        setHeightState(
            setActive ? '0px' : `500px`, // `${content.current.scrollHeight}px` TODO: should be a dynamic size but for some reason it's allways 0! To be invesgigated in the future...
        );
        setActiveState(!setActive);
    }

    return (
        <li className={classNames(['accordion-item', setActive ? 'is-active' : ''])}>
            <a href="#" className={'accordion-title'} onClick={(e) => toggleAccordion(e)}>
                <span>{props.title}</span>
            </a>
            <div
                className={'accordion-content'}
                ref={content}
                style={{ maxHeight: `${setHeight}`, display: setActive ? 'block' : 'none' }}
            >
                <span dangerouslySetInnerHTML={{ __html: props.content }} />
            </div>
        </li>

    );
}
export default Accordion;
